import { css, cx } from "@linaria/core"
import { styled } from "@linaria/react"

export const Loader = (props: {
  global?: boolean
  visible?: boolean
}) => {
  const className = cx(
    props.global ? Global : null,
    props.visible === undefined || props.visible ? Visible : Invisible
  )

  return (
    <Container className={className}>
      <FirstStripe />
      <SecondStripe />
      <ThirdStripe />
      <FourthStripe />
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  overflow: hidden;

  width: 100%;
  height: 2px;
  margin-bottom: -2px;

  background: var(--loader-one);

  animation: 500ms ease 0s 1 normal none running opacity-animation;
  transition: opacity 0.3s ease-in-out;

  @keyframes opacity-animation {
    0% {
      opacity: 0;
    }

    10% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }
`

const Global = css`
  position: sticky;
  top: 0;

  z-index: var(--z-index-dropdown);
`

const Visible = css`
  opacity: 1;
`

const Invisible = css`
  opacity: 0;
`

const Stripe = styled.div`
  position: absolute;
  left: 50%;

  display: inline;
  width: 0;
  height: 100%;

  text-align: center;
`

const FirstStripe = styled(Stripe)`
  background-image: linear-gradient(
    to right,
    var(--loader-one) 0%,
    var(--loader-three) 10%,
    var(--loader-three) 90%,
    var(--loader-one) 100%
  );

  animation: 2s linear 0s infinite normal none running width-animation,
             4s linear 0s infinite normal none running z-index-animation;

  @keyframes width-animation {
    0% {
      left: 50%;
      width: 0;
    }

    50% {
      left: -10%;
      width: 120%;
    }

    100% {
      left: -10%;
      width: 120%;
    }
  }

  @keyframes z-index-animation {
    0% {
      z-index: 10;
    }

    100% {
      z-index: 5;
    }
  }
`

const SecondStripe = styled(Stripe)`
  background-image: linear-gradient(
    to right,
    var(--loader-three) 0%,
    var(--loader-one) 10%,
    var(--loader-one) 90%,
    var(--loader-three) 100%
  );

  animation: 2s linear 1s infinite normal none running width-animation,
             4s linear 1s infinite normal none running z-index-animation;

  @keyframes width-animation {
    0% {
      left: 50%;
      width: 0;
    }

    50% {
      left: -10%;
      width: 120%;
    }

    100% {
      left: -10%;
      width: 120%;
    }
  }

  @keyframes z-index-animation {
    0% {
      z-index: 10;
    }

    100% {
      z-index: 5;
    }
  }
`

const ThirdStripe = styled(Stripe)`
  background-image: linear-gradient(
    to right,
    var(--loader-one) 0%,
    var(--loader-two) 10%,
    var(--loader-two) 90%,
    var(--loader-one) 100%
  );

  animation: 2s linear 0s infinite normal none running width-animation,
             4s linear 2s infinite normal none running z-index-animation;

  @keyframes width-animation {
    0% {
      left: 50%;
      width: 0;
    }

    50% {
      left: -10%;
      width: 120%;
    }

    100% {
      left: -10%;
      width: 120%;
    }
  }

  @keyframes z-index-animation {
    0% {
      z-index: 10;
    }

    100% {
      z-index: 5;
    }
  }
`

const FourthStripe = styled(Stripe)`
  background-image: linear-gradient(
    to right,
    var(--loader-two) 0%,
    var(--loader-one) 10%,
    var(--loader-one) 90%,
    var(--loader-two) 100%
  );

  animation: 2s linear 1s infinite normal none running width-animation,
             4s linear 3s infinite normal none running z-index-animation;

  @keyframes width-animation {
    0% {
      left: 50%;
      width: 0;
    }

    50% {
      left: -10%;
      width: 120%;
    }

    100% {
      left: -10%;
      width: 120%;
    }
  }

  @keyframes z-index-animation {
    0% {
      z-index: 10;
    }

    100% {
      z-index: 5;
    }
  }
`